export const TIP_FONT = {
  fontSize: 18,
  lineHeight: 1.35,
  padding: '10px 14px',
  backgroundColor: 'var(--qc-btn-bg, #3b6ea5) !important',
  color: 'var(--qc-btn-fg, #f8fafc) !important',
};

export const tipSlotProps = { tooltip: { sx: TIP_FONT } };
